import { render, staticRenderFns } from "./SealApply.vue?vue&type=template&id=35215a08&scoped=true"
import script from "./SealApply.vue?vue&type=script&lang=js"
export * from "./SealApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35215a08",
  null
  
)

export default component.exports